import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormGroup, Label } from 'reactstrap';
import { Field, formValueSelector } from 'redux-form';
import { renderInput, required, Required } from '../../helpers/formHelper';

class View extends PureComponent {
  render() {
    const {
      displays,
    } = this.props;
    return (
      <>
        <Field name="school_application[school_application_tag_id]" type="hidden" component="input" />
        <h2>日程選択</h2>
        <FormGroup>
          <Label>日程</Label>
          <Required />
          <Field
            name="simple_event_entry[simple_event_program_id]"
            type="select"
            component={renderInput}
            validate={[required]}
            id="simple_event_entry_simple_event_program_id"
          >
            <option value="">お選びください</option>
            {displays.simple_event_programs.map((x) => (
              <option key={x.id} value={x.id} disabled={x.disabled}>
                {x.date}
                {' '}
                {x.name}
                {' '}
                {x.status && `【${x.status}】`}
              </option>
            ))}
          </Field>
        </FormGroup>
      </>
    );
  }
}

View.propTypes = {
  displays: PropTypes.shape({
    simple_event_programs: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      date: PropTypes.string,
      disabled: PropTypes.bool,
      status: PropTypes.string,
    })).isRequired,
  }).isRequired,
  formValues: PropTypes.shape({
    authenticity_token: PropTypes.string,
  }).isRequired,
};

const selector = formValueSelector('schoolEntryIndex');
export default connect((state) => ({
  formValues: selector(
    state,
    'authenticity_token',
    'simple_event_entry[simple_event_program_id]',
  ),
}))(View);
